const DEFAULT_CARD_CLASS = "border border-border rounded-md bg-card p-4";

export default function StatusCountCards({ cards = [], className = "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3" }) {
    if (!cards.length) return null;

    return (
        <div className={className}>
            {cards.map((card) => (
                <div key={card.label} className={DEFAULT_CARD_CLASS}>
                    <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">{card.label}</div>
                    <div className={`font-heading text-2xl font-bold mt-2 ${card.valueClassName || ""}`}>{card.value}</div>
                    {card.hint ? <div className="text-xs text-muted-foreground mt-1">{card.hint}</div> : null}
                </div>
            ))}
        </div>
    );
}
